import React, {Component} from 'react';
import PropTypes from 'prop-types';

const CACHE = {};

export default class PreloadedImage extends Component {
    static propTypes = {
        src: PropTypes.string.isRequired,
        aspectRatio: PropTypes.number,
        crossOrigin: PropTypes.string,
        placeholderProps: PropTypes.object,
        loadingComponent: PropTypes.node,
        errorComponent: PropTypes.node,
        hidden: PropTypes.bool,
        onError: PropTypes.func,
        onLoad: PropTypes.func,
    };

    static defaultProps = {
        crossOrigin: 'use-credentials',
        placeholderProps: {},
    };

    state = {};

    componentDidMount() {
        this.preload(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.src !== nextProps.src || this.props.hidden !== nextProps.hidden) {
            this.preload(nextProps);
        }
    }

    componentWillUnmount() {
        this.unmounting = true;
    }

    handleError = (e, src) => {
        if (this.unmounting) {
            return;
        }
        console.error(e);
        CACHE[src] = CACHE[src] ? 1 : CACHE[src] + 1;
        this.setState({loading: false, loaded: false, error: `Failed to load url ${src}`});
        if (this.props.onError) {
            this.props.onError(e, src);
        }
    };

    handleLoad = (src) => {
        if (this.unmounting) {
            return;
        }
        CACHE[src] = true;
        this.setState({loading: false, loaded: true, error: null});
        if (this.props.onLoad) {
            this.props.onLoad(src);
        }
    };

    preload = (props) => {
        if (this.unmounting) {
            return;
        }
        const {src, hidden} = props;
        if (hidden) {
            return;
        }
        if (CACHE[src] === true) {
            this.setState({loading: false, loaded: true, error: null});
            return;
        }
        if (CACHE[src] && CACHE[src] > 3) {
            console.error(`Failed to load url ${src} after 3 attempts`);
            this.setState({loading: false, loaded: false, error: `Failed to load url ${src}`});
            return;
        }
        this.setState({loading: true, loaded: false, error: null});
        const img = new Image();
        img.crossOrigin = props.crossOrigin;
        img.onload = () => this.handleLoad(src);
        img.onerror = (e) => this.handleError(e, src);
        img.src = src;
        if (img.complete) {
            this.handleLoad(src);
        }
    };


    render() {
        const {src, hidden, aspectRatio, crossOrigin, loadingComponent, errorComponent, placeholderProps, ...rest} = this.props;
        const {loading, loaded, error} = this.state;
        if (loaded) {
            return <img crossOrigin={crossOrigin} alt={src} src={src} {...rest}/>;
        }
        let content;
        if (!hidden && loading && loadingComponent) {
            const LoadingComponent = loadingComponent;
            content = <LoadingComponent/>;
        }
        if (!hidden && error && errorComponent) {
            const ErrorComponent = errorComponent;
            content = <ErrorComponent error={error}/>;
        }
        const style = aspectRatio ? {paddingBottom: `${aspectRatio * 100}%`} : {};
        return <div style={style} {...placeholderProps}>{content}</div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/PreloadedImage.js